import { Icon } from 'core-ui';
import { Svg } from 'src/assets/icons/DatePickerIcon/svg';
import { CustomIconComponentProps } from 'src/models/icon';

export const DatePickerIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={Svg} {...props} />
);
